import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";

import { Dialog } from 'primereact/dialog';
import { Button } from '../../../../components/ui/Button';
import { Checkbox } from 'primereact/checkbox';
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';
import { Message } from 'primereact/message';
import { isEmpty } from 'lodash';
import { setLastElement, setParams } from '../../../../redux/Slices/popupScrollSlice';
import { Dropdown } from 'primereact/dropdown';
import PopupScrollContainer from '../../../SharedComponents/PopupScrollContainer';
import MediaStack from '../../../SharedComponents/AddContentPopup/MediaStack';
import { Tooltip } from 'primereact/tooltip';
import PopupScrollSearchInput from '../../../SharedComponents/AddContentPopup/PopupScrollSearchInput';
import { useAssignPlaylistMedia, useGetCompanyTags } from '../../../../queries';
import { MultiSelect } from 'primereact/multiselect';
import TagSelector from './TagSelector';

function UploadToPlaylist({ item }) {
    const { t } = useTranslation();
    const lastElementRef = useRef(null);
    const dispatch = useDispatch();

    const { openDialog, companyTags } = useSelector((state) => state.global);
    const { isFetching, data, params } = useSelector((state) => state.popupScroll);
    const { mutate: assignMediaPlaylist, isLoading } = useAssignPlaylistMedia();

    const [ids, setIds] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);

    const onSubmit = () => {
        assignMediaPlaylist({
            id: item.id,
            data: { ids_list: ids }
        });
    };




    useGetCompanyTags();

    useEffect(() => {
        if (lastElementRef.current) {
            dispatch(setLastElement(lastElementRef.current));
        }
    }, [lastElementRef.current]);

    const renderFooter = () => (
        <div>
            <Button
                label={t('media.media_add_to_playlist_btn')}
                className="p-button-sm py-2 px-4 me-0"
                loading={isLoading}
                disabled={ids.length === 0 || isLoading}
                onClick={onSubmit}
            />
        </div>
    );

    const onClose = () => {
        dispatch(toggleDialog("uploadToPlaylist"));
    };

    const selectAll = () => {
        if (!allSelected) {
            const allIds = data?.map(item => String(item.id)) || [];
            setIds(allIds);
            setAllSelected(true);
        } else {
            setIds([]);
            setAllSelected(false);
        }
    };

    const onPlaylistChange = (e) => {
        let selectedPlaylists = [...ids];

        if (e.checked) {
            selectedPlaylists.push(e.value);
        } else {
            selectedPlaylists = selectedPlaylists.filter(id => id !== e.value);
        }

        setIds(selectedPlaylists);
    };

    // Build params with tag filter
    let _params = {
        per_page: 10,
    };

    const handleRemove = (tag) => {
        const updated = selectedTags.filter(t => t.id !== tag.id);
        setSelectedTags(updated);
        // handleTagChange(updated.map(t => t.id)); // ✅ send IDs to parent
        dispatch(setParams({ ...params, tags: ids }))
    };

    return (
        <Dialog
            id="assignDeviceDialog"
            header={t('media.media_select_playlist_header', { name: item.file_name || t('media.media_default_name') })}
            visible={openDialog.uploadToPlaylist}
            onHide={onClose}
            style={{ width: "55vw", minHeight: "70vh" }}
            footer={renderFooter}
        >
            <div className="d-flex device_assign_container border-top border-bottom min-h-[57vh]">
                <div className="w-100 d-flex flex-column justify-start">
                    <div className="d-flex flex-wrap justify-content-center px-1">
                        <div className="w-100 gap-2  m-3 flex justify-between items-center ">
                            <div className="flex-grow">
                                <PopupScrollSearchInput isDisabled={data?.length === 0} />
                            </div>
                            <div className="col-2">

                                <TagSelector
                                    options={companyTags}
                                    selectedTags={selectedTags}
                                    setSelectedTags={setSelectedTags}
                                    placeholder={t('media.media_filter_by_tags')}
                                    handleTagChange={(ids) => {
                                        dispatch(setParams({ ...params, tags: ids }));
                                    }}
                                />


                            </div>

                            <div className=" flex justify-center">
                                <Button
                                    label={t('media.media_clear_all')}
                                    icon="pi pi-times"
                                    className="py-2 px-2 !border-[#aaa]  !text-[#aaa] p-button-secondary p-button-outlined"
                                    onClick={() => {
                                        dispatch(setParams({ ...params, search: "", tags: [] }));

                                        setSelectedTags([]);
                                    }} // ✅ clear tag filter
                                />
                            </div>
                            <div className="flex justify-center">
                                <Checkbox
                                    name="campaign"
                                    className="me-2"
                                    onChange={selectAll}
                                    checked={allSelected}
                                />
                            </div>
                        </div>
                        {selectedTags.length > 0 && (
                            <div className=" mx-3 mb-3 w-100 flex flex-wrap gap-1">
                                {selectedTags.map((tag, index) => {
                                    return (<small className='border rounded-full px-2 text-[13px] cursor-pointer' onClick={() => handleRemove(tag)}>
                                        {tag.name.length > 15 ? tag.name.slice(0, 10) + "..." : tag.name}
                                    </small>
                                    )
                                })}
                            </div>
                        )}

                        <hr className="w-100 mt-0" />

                        <div className="scroll_container scroll_div w-100">
                            <PopupScrollContainer
                                path={`/playlist/company`}
                                showLoading={false}
                                optionalParam={_params} // ✅ tag filter goes here
                            >
                                {data?.length === 0 && !isFetching ? (
                                    <div className="d-flex p-5 justify-content-center">
                                        <Message
                                            className="fw-bold fs-3 p-4 w-100"
                                            severity="warn"
                                            text={
                                                isEmpty(params?.search)
                                                    ? t('media.media_no_playlists_yet')
                                                    : t('messages.no_results')
                                            }
                                        />
                                    </div>
                                ) : (
                                    <div className="flex flex-col gap-2 px-3">
                                        {data?.map((item, index) => {
                                            const isLastElement = index === data?.length - 1;
                                            return (
                                                <div
                                                    key={`${item.type}-${index}`}
                                                    ref={isLastElement ? lastElementRef : null}
                                                    className={`${ids.includes(`${item.id}`)
                                                        ? "rounded-lg border-3 !border-[#8e90f5]"
                                                        : ""
                                                        } hover:shadow-md hover:border-2 col-12 flex items-center justify-between rounded-lg border-1 py-2`}
                                                >
                                                    <label htmlFor={item.id} className="col-10 col-sm-11 d-flex ">
                                                        <div className="col-3 flex justify-center items-center col-sm-2 mx-2 px-4">
                                                            <div className="me-2 p-4 rounded-2 bg-secondary d-flex align-items-center justify-content-center">
                                                                <i className="fas fa-list-ul fs-4 text-white"></i>
                                                            </div>
                                                        </div>
                                                        <div className="col-4 mx-1 fs-6 flex flex-col justify-center items-start text-truncate">
                                                            {item.name}
                                                            {item.status === "INACTIVE" && (
                                                                <div className="gap-1 text-muted text-[12px] flex justify-start items-center">
                                                                    <i
                                                                        className="draftedItem cursor-default fa-solid fa-circle-exclamation"
                                                                        data-pr-position="bottom"
                                                                        data-pr-tooltip={t('media.media_publish_required_tooltip')}
                                                                    ></i>
                                                                    <div
                                                                        className="draftedItem cursor-default"
                                                                        data-pr-position="bottom"
                                                                        data-pr-tooltip={t('media.media_publish_required_tooltip')}
                                                                    >
                                                                        {t('media.media_publish_required')}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {Array.isArray(item?.tags_list) &&
                                                                item.tags_list.length > 0 ? (
                                                                <div className="flex flex-wrap">
                                                                    {item.tags_list.map((tag, index) => (
                                                                        <div
                                                                            key={index}
                                                                            className="flex items-center bg-gray-50 border-2 px-2 shadow-xs rounded-full cursor-pointer transition-all duration-150 hover:bg-white hover:font-bold hover:text-gray-600"
                                                                        >
                                                                            <i className="pi pi-tag text-[15px] pr-1 text-gray-500"></i>
                                                                            <small className="text-start">
                                                                                {tag.name}
                                                                            </small>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ) : null}

                                                            <Tooltip target=".draftedItem" showDelay={100} className="fs-8" />
                                                        </div>
                                                        <div className="col-3 flex items-center text-center text-light">
                                                            {item.media?.length !== 0 ? (
                                                                <MediaStack mediaArray={item.media} />
                                                            ) : (
                                                                t('media.media_empty_playlist')
                                                            )}
                                                        </div>
                                                    </label>
                                                    <div className="col-2 col-sm-1 pe-2">
                                                        <Checkbox
                                                            inputId={item.id}
                                                            name="media"
                                                            className="me-3"
                                                            value={item.id}
                                                            onChange={onPlaylistChange}
                                                            checked={ids.includes(`${item.id}`)}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </PopupScrollContainer>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default UploadToPlaylist;
